"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _orderEntryFormConstants = require("../../constants/sendOrder/orderEntryFormConstants");
var _ReportBlockTradeComponent = _interopRequireDefault(require("./ReportBlockTradeComponent"));
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _modalActions = require("../../redux/actions/modalActions");
var _VerificationRequiredContainer = _interopRequireDefault(require("../VerificationRequired/VerificationRequiredContainer"));
var _store = _interopRequireDefault(require("../../redux/store"));
var _sidePaneActions = require("../../redux/actions/sidePaneActions");
var _kycLevelsSelectors = require("../../redux/selectors/kycLevelsSelectors");
var _productPositionSelectors = require("../../redux/selectors/productPositionSelectors");
var _orderEntrySelector = require("../../redux/selectors/orderEntrySelector");
var _numberFormatter = require("../../helpers/numberFormatter");
var _orderHelper = require("../../helpers/orderHelper");
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var closeSidePane = function closeSidePane() {
  return _store["default"].dispatch((0, _sidePaneActions.closeReportBlockTradeSidePane)());
};
var mapStateToProps = function mapStateToProps(state, _ref) {
  var useNewForm = _ref.useNewForm;
  var form = state.form,
    product = state.apexCore.product;
  var decimalPlaces = product.decimalPlaces;
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var _kycVerificationLevel = (0, _kycLevelsSelectors.kycVerificationLevelsSelector)(state),
    disableTrading = _kycVerificationLevel.disableTrading;
  var formObj = form.reportBlockTrade || {
    values: {}
  };
  var instruments = (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
  var orderTotal = (0, _orderEntrySelector.orderTotalSelector)(state, {
    formName: 'reportBlockTrade',
    useNewForm: useNewForm
  });
  var orderNet = (0, _orderHelper.getOrderNet)(formObj.values, selectedInstrument, orderTotal);
  return _objectSpread(_objectSpread({
    instruments: instruments,
    selectedInstrument: selectedInstrument,
    formObj: formObj,
    decimalPlaces: decimalPlaces
  }, (0, _instrumentPositionSelectors.instrumentPositionsSelector)(state)), {}, {
    products: (0, _productPositionSelectors.productsSelector)(state),
    orderTotal: "".concat(selectedInstrument.Product2Symbol, " ").concat((0, _numberFormatter.formatNumberToLocale)(orderTotal, selectedInstrument.Product2Symbol)),
    orderNet: orderNet,
    initialValues: {
      useNewForm: useNewForm,
      side: formObj.values.side || _orderEntryFormConstants.buyValue,
      instrument: selectedInstrument.InstrumentId,
      quantity: '',
      fee: {
        OrderFee: '0'
      },
      totalAmount: '0',
      price: '',
      counterparty: '',
      orderType: _orderEntryFormConstants.orderTypes.reportBlockTrade.displayName,
      lockedIn: false
    },
    disableTrading: disableTrading,
    VerificationRequiredComponent: /*#__PURE__*/_react["default"].createElement(_VerificationRequiredContainer["default"], {
      onVerificationLinkClick: closeSidePane
    }),
    showLockedIn: _config["default"].BlockTrade.showLockedIn
  });
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var useNewForm = _ref2.useNewForm;
  return {
    onSubmit: function onSubmit() {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.CONFIRM_BLOCK_REPORT, {
        useNewForm: useNewForm
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)({
  form: 'reportBlockTrade',
  enableReinitialize: true
})(_ReportBlockTradeComponent["default"]));